import { MutableRefObject, useEffect, useRef } from 'react';
import { RichTextAreaContext, RichTextAreaPlugin } from '@app/ui';
import { ReactEditor } from 'slate-react';
import { Transforms } from 'slate';

export type RichTextAreaAutoFocusPluginExtra = {
  control?: MutableRefObject<RichTextAreaContext>;
};

export function createRichTextAreaAutoFocusPlugin(
  autoFocus?: boolean,
): RichTextAreaPlugin<object, RichTextAreaAutoFocusPluginExtra> {
  return (Component) => {
    return (props) => {
      const ref = props.control ?? useRef<RichTextAreaContext | null>(null);

      useEffect(() => {
        if (!autoFocus) return;

        const observer = new MutationObserver(() => {
          const editor = ref.current?.editor;
          if (editor) {
            ReactEditor.focus(editor);
            Transforms.select(editor, {
              anchor: { path: [0, 0], offset: 0 },
              focus: { path: [0, 0], offset: 0 },
            });
            observer.disconnect();
          }
        });

        observer.observe(document.body, { subtree: true, childList: true });

        return () => observer.disconnect();
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [autoFocus]);

      return <Component {...props} control={ref} />;
    };
  };
}
